import React from 'react';
import { numberToWords } from '../numberToWords';

const TemplateGov = ({ invoice, seller }) => {
    const isInterState = invoice.sellerState !== invoice.placeOfSupply;

  return (
    <div className="p-4 w-[210mm] min-h-[297mm] mx-auto bg-white text-[11px] border-[1.5px] border-black leading-tight">
      <div className="text-center border-b border-black pb-2 mb-0">
        <h1 className="text-sm font-bold uppercase underline">Tax Invoice</h1>
        <p className="text-[10px]">(Issued under Rule 46 of the Central Goods and Services Tax Rules, 2017)</p>
      </div>

      <div className="grid grid-cols-2 border-b border-black">
        <div className="border-r border-black p-2">
          <p className="font-bold text-sm">{seller.name}</p>
          <p>{seller.address}</p>
          <p className="mt-1"><b>GSTIN:</b> {seller.gstin}</p>
          <p><b>State:</b> {seller.sellerState} (Code: {seller.gstin.substring(0, 2)})</p>
        </div>
        <div className="p-2 space-y-1">
          <p><b>Invoice No:</b> <span className="text-sm font-bold">{invoice.invoiceNo}</span></p>
          <p><b>Date:</b> {invoice.invoiceDate}</p>
          <p><b>Transport Mode:</b> Road</p>
          <p><b>Place of Supply:</b> {invoice.placeOfSupply}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 border-b border-black">
        <div className="border-r border-black p-2">
          <p className="font-bold underline mb-1">Details of Receiver (Bill to):</p>
          <p><b>Name:</b> {invoice.customerName}</p>
          <p><b>Address:</b> {invoice.shippingAddress}</p>
          <p><b>GSTIN:</b> {invoice.customerGstin}</p>
          <p><b>State:</b> {invoice.placeOfSupply}</p>
        </div>
        <div className="p-2">
          <p className="font-bold underline mb-1">Details of Consignee (Ship to):</p>
          <p>Same as Receiver</p>
        </div>
      </div>

      {/* 4. Product Table */}
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b border-black text-center font-bold">
            <th className="border-r border-black p-1 w-8">S.N.</th>
            <th className="border-r border-black p-1">Description of Goods</th>
            <th className="border-r border-black p-1">HSN Code</th>
            <th className="border-r border-black p-1 w-12">Qty</th>
            <th className="border-r border-black p-1 w-16">Rate</th>
            <th className="border-r border-black p-1 w-16">Disc.</th>
            <th className="border-r border-black p-1">Taxable Value</th>
          </tr>
        </thead>
        <tbody>
          {invoice.items.map((item, i) => {
            const taxableValue = (Number(item.qty) * Number(item.rate)) - Number(item.discount);
            return (
              <tr key={i} className="border-b border-black text-center h-10">
                <td className="border-r border-black p-1">{i + 1}</td>
                <td className="border-r border-black p-1 text-left">{item.name}</td>
                <td className="border-r border-black p-1">{item.hsn}</td>
                <td className="border-r border-black p-1">{item.qty} {item.unit}</td>
                <td className="border-r border-black p-1">{Number(item.rate).toFixed(2)}</td>
                <td className="border-r border-black p-1">{Number(item.discount).toFixed(2)}</td>
                <td className="border-r border-black p-1 text-right">{taxableValue.toFixed(2)}</td>
              </tr>
            );
          })}
          <tr className="h-40 border-b border-black">
            <td className="border-r border-black"></td>
            <td className="border-r border-black"></td>
            <td className="border-r border-black"></td>
            <td className="border-r border-black"></td>
            <td className="border-r border-black"></td>
            <td className="border-r border-black"></td>
            <td className="border-r border-black"></td>
          </tr>
        </tbody>
      </table>

      <div className="grid grid-cols-2 border-b border-black">
        <div className="p-2 border-r border-black">
          <p className="font-bold mb-1 underline">Total Amount in Words:</p>
          <p className="italic font-bold">{numberToWords(invoice.total) }</p>
        </div>
        <div className="p-0">
          <table className="w-full text-right">
            <tbody>
              <tr className="border-b border-black">
                <td className="p-1 border-r border-black">Total Taxable Value</td>
                <td className="p-1 w-24">{(invoice.total / 1.18).toFixed(2)}</td>
              </tr>
              {isInterState ? (
                <tr className="border-b border-black font-bold">
                  <td className="p-1 border-r border-black">Integrated Tax (IGST) 18%</td>
                  <td className="p-1">{(invoice.total - (invoice.total / 1.18)).toFixed(2)}</td>
                </tr>
              ) : (
                <>
                  <tr className="border-b border-black">
                    <td className="p-1 border-r border-black">Central Tax (CGST) 9%</td>
                    <td className="p-1">{((invoice.total - (invoice.total / 1.18)) / 2).toFixed(2)}</td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="p-1 border-r border-black">State Tax (SGST) 9%</td>
                    <td className="p-1">{((invoice.total - (invoice.total / 1.18)) / 2).toFixed(2)}</td>
                  </tr>
                </>
              )}
              <tr className="font-bold bg-gray-50 text-sm">
                <td className="p-1 border-r border-black uppercase text-center">Total Value (Inclusive of Taxes)</td>
                <td className="p-1 text-right font-bold">₹ {invoice.total.toLocaleString()}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* 6. Legal & Signatory */}
      <div className="grid grid-cols-2 mt-0 border-b border-black h-24">
        <div className="p-2 border-r border-black text-[9px]">
          <p className="font-bold underline">Declaration:</p>
          <p>We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.</p>
        </div>
        <div className="p-2 text-center relative">
          <p className="font-bold">For {seller.name}</p>
          <div className="absolute bottom-2 left-0 right-0">
            <p className="text-[10px] uppercase">Authorised Signatory</p>
          </div>
        </div>
      </div>
      
      <div className="text-center p-1 text-[9px]">
        <p>This is a computer generated invoice and does not require a physical signature.</p>
      </div>
    </div>
  );
};

export default TemplateGov;